import type { Route } from "./+types/talks";
import Page from "../pages/Talks";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.talks() }; }
export const meta = () => pageMeta({ title: "Talks | Gazar", description: "Talks and presentations on system design, engineering leadership, and shipping software for 16+ years.", path: "/talks", image: OG_IMAGE.talks });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
